import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { fontstyle1, fontstyle2, fontstyle3 } from "../../../utils/fonts";
import instance from "../../../utils/axios";
import ColorsTheme from "../../../utils/colors";
import ThemeContext from "../../../context";

const WelcomeMsg = () => {
  const [username, setUsername] = useState("");
  const [userscount, setUserscount] = useState(0);
  const [feedbackcount, setFeedbackcount] = useState(0);
  const [copied, setCopied] = useState(false);
  const { id, pid } = useParams();
  const { theme } = useContext(ThemeContext);
  const colorthemes = theme !== "light" ? ColorsTheme.light : ColorsTheme.dark;

  useEffect(() => {
    // get the username
    instance
      .post("/username", {
        uid: id
      })
      .then((res) => {
        setUsername(res.data.username.username);
      });

    // get the unique users count based on email id
    instance
      .post("/getuniqueusers", {
        uid: id,
        pid: pid
      })
      .then((res) => {
        setUserscount(res.data.data.length);
      })
      .catch((err) => console.log(err));

    // get the no of feedback count
    instance
      .post("/getFeedbacks", {
        uid: id,
        pid: pid
      })
      .then((res) => {
        setFeedbackcount(res.data.data.length);
      })
      .catch((err) => console.log(err));
  }, [id, pid]);

  return (
    <div className="w-full flex flex-col sm:flex-row justify-between items-center gap-10">
      <div>
        <div className="text-xl ">
          <p style={fontstyle1}>Welcome, {username}</p>
        </div>

        <div className="text-base flex flex-col">
          <p style={fontstyle3}>
            Here’s what’s happening on your{" "}
            <span style={fontstyle2}>{pid.split("-")[1]}</span> account today.
          </p>
          <CopyToClipboard
            text={`https://dofeeedbackin.herokuapp.com/dofeedbackin/api/sdk?uid=${id}&pid=${pid}`}
            onCopy={() => setCopied(true)}
          >
            <span
              className={`text-green-800 w-24 border-${colorthemes.background} border-2 pl-2 pr-2 rounded-full ml-0 mt-2 cursor-pointer`}
              style={fontstyle1}
            >
              copy url
            </span>
          </CopyToClipboard>

          {copied ? (
            <span style={{ color: "red" }} className="pl-3">
              Copied.
            </span>
          ) : null}
        </div>
      </div>
      <div className="flex gap-5">
        <div className="w-full flex flex-col gap-3 items-center justify-center">
          <div
            className="h-20 w-20 bg-black rounded text-white text-2xl flex items-center justify-center"
            style={fontstyle3}
          >
            {userscount}
          </div>
          <div className="text-sm" style={fontstyle1}>
            Users
          </div>
        </div>

        <div className="w-full flex flex-col gap-3 items-center justify-center">
          <div
            className="h-20 w-20 bg-black rounded text-white text-2xl flex items-center justify-center"
            style={fontstyle3}
          >
            {feedbackcount}
          </div>
          <div className="text-sm text-center" style={fontstyle1}>
            Feedbacks
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeMsg;
